import React from 'react'
import ButtonService from '../components/Service/ButtonService'

function Status(props) {

    const { list, status_id, ticket_id } = props

    const current = list.filter((item) => item.id === status_id)

    const prev = list.filter(function (el) {
        if (!current['0'].way.pre) {
            return null
        }
        const temp = current['0'].way.pre;
        if (temp.length === 2) {
            return (el.way.cur['0'] === current['0'].way.pre['0'] || el.way.cur['0'] === current['0'].way.pre['1'])
        } else if (temp.length === 3) {
            return (el.way.cur['0'] === current['0'].way.pre['0'] || el.way.cur['0'] === current['0'].way.pre['1'] || el.way.cur['0'] === current['0'].way.pre['2'])
        }
        else {
            return (el.way.cur['0'] === current['0'].way.pre['0'])
        }

    });



    let next = list.filter(function (el) {
        if (!current['0'].way.next) {
            return null
        }

        const temp = current['0'].way.next;
        if (temp.length === 2) {
            return (el.way.cur['0'] === temp['0'] || el.way.cur['0'] === temp['1'])
        } else {
            // return (el.way.cur['0'] === current['0'].way.next['0'])
            return (el.way.cur['0'] === current['0'].way.next['0'])
        }

    })

    next = next.filter((item) => item.in_desk)
    const cur = current;

    if (!cur || !next) {
        return null
    }

    if (!props.access.status.read) {
        return null
    }

    let renderStatus = (obj, access = true, title, color, icon, deny, disabled, name, repair_list) => {
        if (obj.length === 0 || !access) {
            return null
        }
        return (
            <div className={`step ${name}`}>
                <div className="step-group">
                    {(title !== 'off') ? <div className="step-title truncate ticket__title">{title}</div> : ''}
                    {obj.map((item) => <ButtonService key={item.id}
                        color={`${color}`}
                        title={item.name}
                        status={item.id}
                        ticket_id={ticket_id}
                        icon={item.icon}
                        short={item.short}
                        list={props.repair_list}
                        disabled={disabled}
                        deny={false}
                        comment={item.comment_require}
                    />)}
                </div>
            </div>
        )
    }

    return (
        <ul className="stepper">
            {renderStatus(cur,
                true,
                'Статус заявки',
                'blue accent-1',
                'flag',
                true,
                true,
                'current'
            )}
            {renderStatus(prev,
                props.access.status.edit,
                'Повернути статус',
                'red lighten-1',
                'navigate_before',
                false,
                false,
                'prev'
            )}

            {renderStatus(next,
                true,
                'Поставити статус',
                'teal lighten-1',
                'navigate_before',
                false,
                false,
                'next'
            )}

        </ul>
    )
}

export default Status


// WEBPACK FOOTER //
// ./src/containers/Status.js